import type {
  SystemWorkspaceDefinition,
} from './SystemWorkspaceContracts';

import {
  projectSystemCertification,
  projectSystemStatus,
} from './SystemStatusProjectionEngine';

import {
  projectTreeSimulationCertification,
} from '../tree-runtime-simulator/TreeSimulationCertificationProjection';

export function projectTreeWorkspace(
  workspace: SystemWorkspaceDefinition,
) {
  if (workspace.id !== 'tree') {
    throw new Error(
      'Tree workspace projection received the wrong system authority.',
    );
  }

  const simulation =
    projectTreeSimulationCertification();

  const projectedCertification = {
    ...workspace.certification,
    simulatedRuntime:
      simulation.simulatedRuntime,
  };

  const projectedWorkspace:
    SystemWorkspaceDefinition = {
      ...workspace,
      certification:
        projectedCertification,
      statusSignals: {
        ...workspace.statusSignals,
        currentEvidenceAvailable:
          true,
        criticalFailure:
          workspace.statusSignals
            .criticalFailure ||
          simulation.status === 'FAIL',
        nonCriticalIssue:
          true,
        reason:
          simulation.status === 'FAIL'
            ? 'Tree simulated-runtime certification failed. Review correctness and scale evidence before continuing.'
            : simulation.status === 'PASS'
              ? `${workspace.statusSignals.reason} Simulated-runtime certification passed; deployed runtime, live transaction, recovery, and mutation-authority certification remain blocked.`
              : `${workspace.statusSignals.reason} Required Tree correctness and scale simulations have not all been completed.`,
      },
    };

  return {
    systemId: workspace.id,
    workspace:
      projectedWorkspace,
    simulation,
    certification:
      projectSystemCertification(
        workspace.id,
        projectedCertification,
      ),
    status:
      projectSystemStatus(
        projectedWorkspace,
      ),
  };
}
